import $ from 'jquery';

export default () => {
  const submitForm = (formId) => {
    const $form = $(`#${formId}`);

    if ( !$form.length ) {
      console.error(`Form #${formId} not found`);
      return;
    }

    if ( !$form.valid() ) {
      if (typeof window.grecaptcha !== 'undefined') {
        window.grecaptcha.reset();
      }
      return;
    }

    $form.trigger('submit');
  };

  window.onInquireSubmit = () => {
    submitForm('inquire-form');
  };

  window.onMeetingSubmit = () => {
    submitForm('meeting-form');
  };

  window.onKiteGlobalSubmit = () => {
    submitForm('kite-global-form');
  };
};


// WEBPACK FOOTER //
// ./src/assets/js/project/recaptcha.js